import axios from "axios";
import Toaster from "../components/Toaster";
// axios.defaults.baseURL = "http://localhost:3001/api/";
axios.defaults.baseURL = "https://mgsvy.orbitaviation.in/api/";


axios.interceptors.request.use(
  function (config) {

    if (localStorage.auth_token) {
      const auth = `Bearer ${localStorage.auth_token}`;
      config.headers.Authorization = auth;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (err) {
    if (!err.response) {
      const temp = new Error("Request Cancelled");
      return Promise.reject(temp);
    }

    const { data, status } = err.response;
    const error = data

    switch (status) {
      case 401:
        Toaster.showError(error.message || 'Something Went Wrong.');
        localStorage.clear();
        setTimeout(() => {
          window.location.reload();
        }, 200)
        break;

      case 403:
        Toaster.showError(error.message || 'Something Went Wrong.');
        break;

      case 404:
        Toaster.showError(error.message || 'Something Went Wrong.');
        break;

      case 400:
        Toaster.showError(error.message || 'Something Went Wrong.');
        break;

      case 412:
        if (error.validation) {
          const firstKey = Object.keys(error.validation)[0];
          if (Array.isArray(error.validation[firstKey])) {
            alert(error.validation[firstKey][0]);
          } else {
            alert(error.validation[firstKey]);
          }
        } else if (error.message || 'Something Went Wrong.') {
          Toaster.showError(error.message || 'Something Went Wrong.');
        } else {
          alert("Something went wrong");
        }
        break;

      case 500:
        Toaster.showError(error.message || 'Something Went Wrong.');
        break;

      default:
        return Promise.reject(error);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axios;